export const handleSubmitForm = (values, mutateUpload) => {
  const uploadData = {
    mobileModelImage: values.mobileModelImage ? values.mobileModelImage[0] : null,
    mobileBrandId: values.mobileBrandId,
    mobileModelCode: values.mobileModelCode,
    mobileModelNameTh: values.mobileModelNameTh,
    mobileModelNameEn: values.mobileModelNameEn,
  };

  mutateUpload(uploadData);
};
